<template>
  <RightMenu
      class="sticky-note-menu"
      :menu-visible="stickyNoteMenuVisible"
      :menu="STICKY_NOTE_MENU"
  >
  </RightMenu>
</template>

<script>
import {getStickyNoteMenu} from "@/components/dashboard/menu/StickyNoteMenuContent";
import StickyNoteCard from "@/components/sticky/StickyNoteCard";
import Events from "@/utils/Events";
import StickyNote from "@/server/com/silkplm/model/sticky/StickyNote";
import RightMenu from "@/components/dashboard/menu/RightMenu";
import {STICKY_NOTE_MENU} from "@/components/dashboard/menu/StickyNoteMenuContent";

export default {
  name: "StickyNoteMenu",
  components: {StickyNoteCard, RightMenu},
  async created() {
  },

  mounted() {
    this.$onEvent(Events.clickedOnStickyNotes, this.clickOnStickyNotes);
  },

  methods: {

    waitForAnimations() {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, 1000);
      });
    },

    async clickOnStickyNotes() {
      let callback = (e) => {
        if (!document.getElementsByClassName('sticky-note-menu')[1] || !document.getElementsByClassName('sticky-note-menu')[1].contains(e.target)) {
          this.$emit('hide-sticky-note-menu');
          window.removeEventListener('click', callback);
        }
      }
      if (this.bellMenuVisible || this.userMenuVisible) {
        if (this.bellMenuVisible) {
          this.$emit('hide-bell');
        } else {
          this.$emit('hide-user-menu');
        }
        await this.waitForAnimations();
        this.$emit('show-sticky-note-menu');
        setTimeout(() => window.addEventListener('click', callback));
        return;
      }

      if (!this.stickyNoteMenuVisible) {
        this.$emit('show-sticky-note-menu');
        setTimeout(() => window.addEventListener('click', callback));
      }
    },

  },

  props: {
    bellMenuVisible: {type: Boolean, default: false},
    stickyNoteMenuVisible: {type: Boolean, default: false},
    userMenuVisible: {type: Boolean, default: false},
  },

  data: () => ({
    STICKY_NOTE_MENU,
    stickyNote: new StickyNote(),
  }),
}

</script>

